import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Table1 from "./Table1";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  MainCostCenterList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                 <div className="row align-items-center g-3">
                  {/* Series */}
                  <div className="col-md-3">
                    <small className="text-muted">Series</small>
                    <div className="fw-semibold text-primary">
                      CC-ALLOC-00001
                    </div>
                  </div>

                  {/* Valid From */}
                  <div className="col-md-3">
                    <small className="text-muted">Valid From</small>
                    <div className="fw-semibold">24-11-2025</div>
                  </div>

                  {/* Company */}
                  <div className="col-md-6">
                    <small className="text-muted">Company</small>
                    <div className="fw-semibold text-warning text-truncate">
                      Lakshmi Narain Diamond (India) Pvt. Ltd.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <div
          className="col-md-12 px-2"
          style={{ display: "flex", gap: "20px" }}
        >
          <div
            className=""
            style={{
              height: "100%",
              borderRadius: "4px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "10px",
              border: "1px solid #DBDBDB",
              borderRadius: "5px",
            }}
          >
            <div style={{ display: "flex", gap: "15px" }}>
              <div style={{ flex: 1 }}>
                <p className="" style={{ fontSize: "16px", fontWeight: "600" }}>
                  Cost Center Allocation Percentages
                </p>
              </div>
            </div>
            <Table1 setselected_item_data={setselected_item_data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
